import axios from 'axios';
import { attachResponseInterceptor, getAuth } from '../modules/auth/core/AuthHelpers';

const auth = getAuth()

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_BACKEND
  //baseURL: 'http://localhost:3333/api/v1/'
  //baseURL: 'https://dash.solarvision.app/api/v1/'
  //baseURL: process.env.REACT_APP_API_URL
});

if (auth?.api_token) {
  api.defaults.headers.common['Authorization'] = `${auth?.api_token}`;
}

api.interceptors.request.use((config) => {
  const currentAuth = getAuth()
  if (currentAuth?.api_token && config.headers) {
    config.headers.Authorization = `${currentAuth.api_token}`
  }
  return config;
});

attachResponseInterceptor(api);

export default api;
